import React from 'react';
import { FaFlagCheckered, FaRegClock } from 'react-icons/fa';
import { MatchResultForm } from '../components';

const Semifinal = ({ semifinalMatches, addSemifinalResult }) => (
  <MatchResultForm
    matches={semifinalMatches}
    onAddResult={addSemifinalResult}
    title="Gran final"
    icon={<FaFlagCheckered />}
    description="Un solo partido define al campeón."
    emptyIcon={<FaRegClock />}
    emptyTitle="Fase pendiente"
    emptyDescription="Completa las eliminatorias para habilitar la final."
    submitLabel="Cerrar final"
    submitButtonClassName="btn btn--primary"
  />
);

export default Semifinal;
